import React, { useEffect, useState } from 'react';
import './sec-booking.css'
import Sidebar from '../component/layout/sidebar';
import Header from '../component/layout/header';
import Header2 from '../component/common/title';
import AddCTA from '../component/common/addcta';
import pic25 from '../assets/pic25.png'
import pic26 from '../assets/pic26.png'
import pic27 from '../assets/pic27.png'
import pic28 from '../assets/pic28.png'
import pic30 from '../assets/pic30.png'
import pic31 from '../assets/pic31.png'
import pic32 from '../assets/pic32.png'
import { supabase } from '../supabase';
import Input from '../component/common/input';
import Select from '../component/common/select';
import pic34 from '../assets/pic34.png'
import pic35 from '../assets/pic35.png'

const Booking = () => {


const [Booking, setBooking] = useState([]);
const [users, setUsers] = useState([]);
const [events, setEvents] = useState([]);
const [showForm, setShowForm] = useState(false);
const [search, setSearch] = useState('');
const [filter, setFilter] = useState('');
const [sort, setSort] = useState('');
const [showDeleteModal, setShowDeleteModal] = useState(false);
const [selectedDeleteId, setSelectedDeleteId] = useState(null);
const [isEditing, setIsEditing] = useState(false);
const [editingId, setEditingId] = useState(null);
const [isSidebarOpen, setIsSidebarOpen] = useState(false);

const [formData, setFormData] = useState({
  user_id: '',
  Event_id: '',
  Number_of_tickets: '',
  status: '',
   status_ar: '',
  price: 0,         
  ticket_type: 'Regular' ,
    ticket_type_ar: 'عادي'
});









// // dah low ana 3awza a5od data mn link 2 tables (el logic)

// useEffect(() => {
//   const getallBooking = async () => {
//     const { data, error } = await supabase
//       .from('Booking')
//       .select(`
//         *,
//         Users:user_id (
//           id,
//           user_name
//         ),
//         Events:Event_id (
//           Event_title
//         )
//       `);

//     if (error) {
//       console.log("FETCH ERROR:", error);
//       setBooking([]);
//       return;
//     }

//     setBooking(data || []);
//     console.log(data);
//   };

//   getallBooking();
// }, []);

useEffect(() => {
  const getallBooking = async () => {
    const { data, error } = await supabase
      .from('Booking')
      .select(`
        *,
        Users:user_id (
          id,
          user_name,
          user_name_ar

        ),
        Events:Event_id (
          Event_title,
            Event_title_ar
        )
      `);

    if (error) {
      console.log("FETCH ERROR:", error);
      setBooking([]);
      return;
    }

    setBooking(data || []);
  };

  const getUsers = async () => {
    const { data, error } = await supabase
      .from('Users')
      .select('id, user_name');

    if (error) {
      console.log("USERS FETCH ERROR:", error);
      return;
    }

    setUsers(data || []);
  };

  const getEvents = async () => {
    const { data, error } = await supabase
      .from('Events')
  .select('id, Event_title, starting_price, max_price');

    if (error) {
      console.log("EVENTS FETCH ERROR:", error);
      return;
    }

    setEvents(data || []);
  };

  getallBooking();
  getUsers();
  getEvents();
}, []);








const filteredBookings = (Booking || [])
  .filter((item) => {
    const matchesSearch =
      (item.Users?.user_name?.toLowerCase() || '').includes(search.toLowerCase()) ||
      (item.Events?.Event_title?.toLowerCase() || '').includes(search.toLowerCase()) ||
      (item.status?.toLowerCase() || '').includes(search.toLowerCase());

    let matchesFilter = true;

    if (filter) {
      if (filter.startsWith('status')) {
        matchesFilter =
          item.status?.toLowerCase() === filter.split('-')[1];
      }
    }

    return matchesSearch && matchesFilter;
  })
  .sort((a, b) => {
    if (sort === 'newest') {
      return new Date(a.booking_date) - new Date(b.booking_date);
    }

    if (sort === 'oldest') {
      return new Date(b.booking_date) - new Date(a.booking_date);
    }

    if (sort === 'priceLow') {
      return Number(a.total_price) - Number(b.total_price);
    }

    if (sort === 'priceHigh') {
      return Number(b.total_price) - Number(a.total_price);
    }

    return 0;
  });

    





const handleClose = () => {
  setShowForm(false);
  setIsEditing(false);
  setEditingId(null);
setFormData({
  user_id: '',
  Event_id: '',
  Number_of_tickets: '',
  status: ''
});

};


const createBooking = async () => {
const pricePerTicket = Number(formData.price);
const totalPrice = pricePerTicket * Number(formData.Number_of_tickets);
  const today = new Date().toISOString().split('T')[0]; 

  const { data, error } = await supabase
    .from('Booking')
    .insert([{
      user_id: Number(formData.user_id),
      Event_id: Number(formData.Event_id),
      Number_of_tickets: Number(formData.Number_of_tickets),
      price: pricePerTicket,
      total_price: totalPrice,
      booking_date: today,
      status: formData.status,
        status_ar: formData.status_ar,
      ticket_type: formData.ticket_type || null,
        ticket_type_ar: formData.ticket_type_ar || null
    }])
    .select(`
      *,
      Users:user_id (id, user_name,user_name_ar),
  Events:Event_id (Event_title, Event_title_ar)
    `);

  if (error) {
    console.log("CREATE ERROR:", error);
    return;
  }

  setBooking(prev => [...prev, ...data]);
  setShowForm(false);
};










const confirmDelete = async () => {
  await supabase
    .from('Booking') 
    .delete()
    .eq('id', selectedDeleteId);

  setBooking(prev => prev.filter(b => b.id !== selectedDeleteId));

  setShowDeleteModal(false);
};






const handleEditClick = (item) => {
setFormData({
  user_id: item.user_id || '',
  Event_id: item.Event_id || '',
  Number_of_tickets: item.Number_of_tickets || '',
  status: item.status || '',
   status_ar: item.status_ar || '',
  price: item.price || 0,
  ticket_type: item.ticket_type || 'Regular',
    ticket_type_ar: item.ticket_type_ar || 'عادي'
});

  setEditingId(item.id);
  setIsEditing(true);
  setShowForm(true);
};


const updateBooking = async () => {
const pricePerTicket = Number(formData.price);
const totalPrice = pricePerTicket * Number(formData.Number_of_tickets);
  const { data, error } = await supabase
    .from('Booking')
    .update({
        Event_id: Number(formData.Event_id),
      Number_of_tickets: Number(formData.Number_of_tickets),
      price: pricePerTicket,
      total_price: totalPrice,
      status: formData.status,
        status_ar: formData.status_ar,
      ticket_type: formData.ticket_type,
        ticket_type_ar: formData.ticket_type_ar
    })
    .eq('id', editingId)
    .select(`
      *,
      Users:user_id (id, user_name,user_name_ar),
      Events:Event_id (Event_title, Event_title_ar)
    `);

  if (error) {
    console.log("UPDATE ERROR:", error);
    return;
  }

  setBooking(prev => prev.map(b => b.id === editingId ? data[0] : b));
  setShowForm(false);
  setIsEditing(false);
};



const STATUS_MAP = {
  Confirmed: 'مؤكد',
  Pending: 'قيد الانتظار'
};




    return ( 
 <section className='main-dashboard-container'>            
            <Sidebar isOpen={isSidebarOpen}  /> 
            <section className='container-right-info'>
                    <section className='header-container'>
                        <Header  onMenuClick={() => setIsSidebarOpen(!isSidebarOpen)}  />
                    </section>

                    <section className='information-container'>
                        <article className='header-cont-event'>
                           <Header2 
                            title="Booking Management"  
                            para="View and manage all ticket bookings"
                            />
                          <AddCTA    title='Add Booking'   onClick={() => setShowForm(true)} />
                        
                        </article>



{showForm && (
  <div className="overlay-create">
    <div className="container-create">

      <div className="header-create">
            <h1 className="title-create">
            {isEditing ? 'Edit Booking' : 'Add New Booking'}
            </h1>

        <button
          className="close-btn-create"
          onClick={handleClose}
          type="button"
        >
          <img src={pic34} alt='close' />
        </button>
      </div>




      <form className="form-create"  onSubmit={(e) => {
                e.preventDefault();
            isEditing ? updateBooking() : createBooking();
            }}>

                                <fieldset className="field-group-create">
                                        <fieldset className="fieldset">
                                          <label className='title-input'>User</label>
                                           <div className="select-wrapper2">
                                        
                                           <img src={pic28} className="arrow-icon2" alt="arrow" />
                                          <select
                                            className="input-search2 select-style2"
                                            value={formData.user_id}
                                            onChange={(e) =>
                                              setFormData({ ...formData, user_id: e.target.value })
                                            }
                                          >
                                            <option value="">Select user</option>
                                            {users.map((user) => (
                                              <option key={user.id} value={user.id}>
                                                {user.user_name}
                                              </option>
                                            ))}
                                          </select>
                                          </div>
                                        </fieldset>
                                  </fieldset>


                                <fieldset className="field-group-create">
                                       <fieldset className="fieldset">
                                        <label className='title-input'>Event</label>
                                        <div className="select-wrapper2">
                                        
                                       <img src={pic28} className="arrow-icon2" alt="arrow" />
                                            <select
                                          className="input-search2 select-style2"
                                          value={formData.Event_id}
                                          onChange={(e) => {
                                            const selectedEvent = events.find(event => event.id === Number(e.target.value));
                                            if (selectedEvent) {
                                              const priceOptions = [];
                                              for (let i = selectedEvent.starting_price; i <= selectedEvent.max_price; i++) {
                                                priceOptions.push(i);
                                              }
                                              setFormData({
                                                ...formData,
                                                Event_id: e.target.value,
                                                priceOptions, 
                                                price: selectedEvent.starting_price,
                                                total_price: selectedEvent.starting_price * Number(formData.Number_of_tickets || 0)
                                              });
                                            }
                                          }}
                                        >
                                          <option value="">Select Event</option>
                                                {events.map((event) => (
                                                <option key={event.id} value={event.id}>
                                                  {event.Event_title}
                                                </option>
                                              ))}
                                        </select>



                                        </div>

                                        
                                          {formData.Event_id && (
                                               <fieldset className="fieldset">
                                              <label className='title-input'>Ticket Price (EGP)</label>
                                               <div className="select-wrapper2">
                                               <img src={pic28} className="arrow-icon2" alt="arrow" />
                                                <select
                                                className="input-search2 select-style2"
                                                value={formData.price}
                                                onChange={(e) => {
                                                  const price = Number(e.target.value);
                                                  const event = events.find(ev => ev.id === Number(formData.Event_id));
                                                  let ticket_type = 'Regular';
                                                  let ticket_type_ar = 'عادي';

                                                  if (event) {
                                                    if (price === event.max_price) {
                                                      ticket_type = 'VIP';
                                                      ticket_type_ar = 'كبار الشخصيات';
                                                    } else {
                                                      ticket_type = 'Regular';
                                                      ticket_type_ar = 'عادي';
                                                    }
                                                  }
                                                  setFormData({
                                                    ...formData,
                                                    price,
                                                    ticket_type, 
                                                    ticket_type_ar,
                                                    total_price: price * Number(formData.Number_of_tickets || 0),
                                                  });
                                                }}
                                                >
                                                {(() => {
                                                  const event = events.find(ev => ev.id === Number(formData.Event_id));
                                                  if (!event) return null;
                                                  return (
                                                    <>
                                                      <option value={event.starting_price}>{event.starting_price} EGP (Regular)</option>
                                                      {event.max_price !== event.starting_price && (
                                                        <option value={event.max_price}>{event.max_price} EGP (VIP)</option>
                                                      )}
                                                    </>
                                                  );
                                                })()}
                                              </select>
                                            </div>
                                          </fieldset>
                                        )}
                                      </fieldset>
                                </fieldset>
                                       
                                <fieldset className="field-group-create">
                                      <Input
                                        title='Number of Tickets'
                                        placeholder='Enter Number'
                                        value={formData.Number_of_tickets}
                                        onChange={(e) => {
                                          const tickets = Number(e.target.value);
                                          setFormData({
                                            ...formData,
                                            Number_of_tickets: tickets,
                                            total_price: tickets * Number(formData.price || 0)
                                          });
                                        }}
                                      />


                                </fieldset>


                                <fieldset className="field-group-create">
                                                <Select title="Status (English)" select1="Confirmed" select2="Pending"
                                                value={formData.status}
                                              onChange={(e) => {
                                                const value = e.target.value;

                                                setFormData({
                                                  ...formData,
                                                  status: value,
                                                  status_ar: STATUS_MAP[value]
                                                });
                                              }}
                                              />

                                              {/* <Select title="Status (Arbic)" select1="مؤكد"  select2="قيد الانتظار"
                                              value={formData.status_ar}
                                             onChange={(e) => {
                                            const value = e.target.value;

                                            setFormData({
                                              ...formData,
                                              status_ar: value,
                                              status: STATUS_MAP_AR[value]
                                            });
                                          }}
                                            /> */}

                                </fieldset>
                                                        <nav className='container-ctas-craete'>
                                                                                    <button   type="button" className="cta-cancel-create" onClick={handleClose}>
                                                                                        <h2 className="cta-cancel-text-create">
                                                                                            Cancel
                                                                                        </h2>
                                                                                    </button>
                                                    
                                                                                    <button type="submit" className='cta-create'>
                                                                                    <h2 className='cta-create-text'>
                                                                                        {isEditing ? 'Edit Booking' : 'Create Booking'}
                                                                                    </h2>
                                                                                    </button>
                                                        </nav>
                                

      </form>
    </div>
  </div>
)}






{showDeleteModal && (
  <section className="delete-modal-overlay">
    <article className="delete-modal" role="dialog" aria-modal="true">
      
      <header className="delete-modal-header">
        <div className="delete-icon-wrapper">
          <img src={pic35} alt='icon'></img>
        </div>

        <div className="delete-text-container">
          <h2 className="delete-title">Delete Event</h2>
          <p className="delete-description">
            Are you sure you want to delete this booking? This action cannot be undone.
          </p>
        </div>
      </header>

      <nav className="delete-modal-actions">
        <button
          className="delete-btn-cancel"
          onClick={() => {
            setShowDeleteModal(false);
            setSelectedDeleteId(null);
          }}
        >
          Cancel
        </button>

        <button
          className="delete-btn-confirm"
          onClick={confirmDelete}
        >
          Delete
        </button>
      </nav>

    </article>
  </section>
)}






                        <section className='container-table-eventp'>
                            <fieldset className="input-wrapper">
                                <input 
                                  className='input-search'
                                    placeholder="Search for booking..."
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)} />
                                <img src={pic25} className="search-icon" alt="search" />
                            </fieldset>
                            <fieldset className='container-inputs-event-p'>
                                  <div className="select-wrapper">
                                    <img src={pic28} className="arrow-icon" alt="arrow" />
                                    <img src={pic26} className="select-icon" alt="filter" />
                                <select
                                className="input-search select-style"
                                value={filter}
                                onChange={(e) => setFilter(e.target.value)}
                                >
                                <option value="">Filter by</option>
                                <option value="status-confirmed">Confirmed</option>
                                <option value="status-pending">Pending</option>
                                </select>
                                </div>


                                <div className="select-wrapper">
                                       <img src={pic28} className="arrow-icon" alt="arrow" />
                                    <img src={pic27} className="select-icon" alt="sort" />
                                    <select
                                    className="input-search select-style"
                                    value={sort}
                                    onChange={(e) => setSort(e.target.value)}
                                    >
                                    <option value="">Sort by</option>
                                    <option value="priceLow">Sort by price (low → high)</option>
                                    <option value="priceHigh">Sort by price (high → low)</option>
                                     <option value="newest">Sort by date (Nearly upcoming)</option>
                                    <option value="oldest">Sort by date (Long-term)</option>
                                    </select>
                                </div>

                            </fieldset>



                                                 <div className="table-container" >
                                <table className='table'>
                                    <thead>
                                    <tr className='table-header'>
                                        <th className='table-header-text'></th>
                                        <th className='table-header-text'>ID</th>
                                        <th className='table-header-text'>User</th>
                                        <th className='table-header-text'>Event</th>
                                        <th className='table-header-text'>Ticket price</th>
                                        <th className='table-header-text'>Total price</th>
                                        <th className='table-header-text'>N0 of Tickets </th>
                                            <th className='table-header-text'>Ticket Type</th>
                                        <th className='table-header-text'>Booking date</th>
                                        <th className='table-header-text'>Status</th>
                                        <th className='table-header-text'>User_ar</th>  
                                        <th className='table-header-text'>Event_ar</th>                                                                              
                                        <th className='table-header-text'>Status_ar</th>
                                          <th className='table-header-text'>Ticket Type_ar</th>
                                        <th className='table-header-text'>Actions</th>
                                    </tr>
                                    </thead>

 {filteredBookings.map((item) => { return <tbody key={item.id}>
                                            <tr className='table2-header'>
                                                <td className='checkbox-cont-table'>
                                                    <label className="custom-checkbox">
                                                    <input type="checkbox" />
                                                    <span className="checkmark"></span>
                                                    </label>
                                                </td>
                                                <td className='mainwhite-table-font'>{item.id}</td>
                                                <td className='container-event'>

                                                    <div className='container-event2'>
                                                        <h2 className='event-title'>{item.Users?.user_name}</h2>
                                                        <h3 className='artistname'>{item.user_id}</h3>
                                                    </div>
                                                </td>
                                                <td className='mainwhite-table-font'>{item.Events?.Event_title}</td>
                                          <td className='mainwhite2-table-font'>{item.price} EGP</td>
                                          <td className='mainwhite2-table-font'>{item.total_price} EGP</td>
                                            <td className='mainwhite-table-font'>{item.Number_of_tickets}</td>
                                            <td className='mainwhite-table-font'>{item.ticket_type}</td> 
                                            <td className='mainwhite-table-font'>{item.booking_date}</td>

                                                <td className='mainwhite-table-font'>
                                                    <div  className={`status-badge ${item.status?.toLowerCase() || ''}`}>
                                                    <div className='status-text'>{item.status}</div>
                                                    </div>
                                                </td>

                                                <td className='mainwhite-table-font_ar'>{item.Users?.user_name_ar}</td>
                                                <td className='mainwhite-table-font_ar'>{item.Events?.Event_title_ar}</td>

                                                <td className='mainwhite-table-font'>
                                                  <div className={`status-badge_ar ${item.status_ar || ''}`}>
                                                    <div className='status-text_ar'>
                                                      {item.status_ar}
                                                    </div>
                                                  </div>
                                                </td>

                                                <td className='mainwhite-table-font_ar'>
                                                  {item.ticket_type_ar}
                                                </td>
                                                
                                                <td className='mainwhite-table-font'>
                                                    <nav className='cta-table'>
                                                            <button className='cta2-table'>
                                                                <img src={pic30} alt='hide'></img>
                                                            </button>
                                                            <button
                                                            className='cta2-table'
                                                            onClick={() => handleEditClick(item)}
                                                            >
                                                            <img src={pic31} alt='edit' />
                                                            </button>
                                                            <button
                                                            className='cta2-table'
                                                            onClick={() => {
                                                                setSelectedDeleteId(item.id);
                                                                setShowDeleteModal(true);
                                                            }}
                                                            >
                                                            <img src={pic32} alt='delete' />
                                                            </button>
                                                            
                                                    </nav>
                                                </td>




                                            </tr>
                                    </tbody>
               })}
                                </table>
                                </div>

                                       




                        </section>







                    </section>

            </section>
        </section>

     );
}
 
export default Booking;